import React from "react"
import MobileDropdown from './nav/MobileDropdown'

function Nav() {
	return (
	<div className="Nav">
		<a className="Logo" href="#welcome">
		JG
		</a>
		<div></div>
		<div className="Links">
		<ul>
			<a href="#about">About</a>
			<a href="#experience">Experience</a>
			<a href="#projects">Projects</a>
			<a href="#contact">Contact</a>
			<a href="/Joseph Guzzardo Resume.pdf">Resume</a>
		</ul>
		</div>
		<MobileDropdown/>
	</div>
  )
}

export default Nav